import { createFileRoute, redirect } from '@tanstack/react-router';

import { SummaryTimeline } from '@/features/summary-timeline/summary-timeline';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/summary-timeline/')({
  beforeLoad() {
    if (userStore.isInternalUser) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: SummaryTimeline,
});
